export const OfficeCreateEditDiscountState = {
	url: '/discount/:id',
	title: 'Office Create/Edit Discount',
	params: {id: null},
	template: '<create-edit-discount-page></create-edit-discount-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCreateDiscountPageMod" */
			'@Containers/office-rebate-discounts-page/office-create-edit-discount/office-create-edit-discount.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
